import React, { useState, useRef } from 'react'
import {
  message,
  Form,
  AutoComplete,
  Input,
  Modal,
  Spin,
  Row,
  Col,
  Button,
  Card
} from 'antd'
import IntlMessages from '../util/IntlMessages'
import ds from '../Services/DataServices'
import { useSelector, useDispatch } from 'react-redux'
import {
  loadSellProductDetails,
  loadSellScreenLoading,
  loadSellVariantProd,
  loadSellSelectedProds,
  loadSellSelectedSingleProd,
  loadCheckProdsVariants,
  loadShowQuickKey
} from '../appRedux/actions/Sell'
import {
  loadIsShowVariantModal,
  loadVariatSelectedProdID
} from '../appRedux/actions/CommonData'
import { set } from 'nprogress'
import { SearchOutlined } from '@ant-design/icons'
import BarcodeReader from 'react-barcode-reader'
import {
  StringIsNullOrEmpty,
  getEncryptedID,
  isString,
  loadSearchSelectedProduct,
  removeSpacewithLowerCaseString
} from '../appRedux/actions'
import ProductSearch from './ProductSearch'
import { isMobile } from 'react-device-detect'
import { LANDSCAPE_QUICK_KEY } from '../constants/ThemeSetting'
import { checkIsWeb } from '../appRedux/actions/MobAppFn'

const formItemLayout = {}

const SearchProduct = props => {
  const screen = props.screen
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  )

  const getReduxSellScreenLoading = useSelector(
    ({ Sell }) => Sell.getSellScreenLoading
  )

  const getReduxSellVariantProduct = useSelector(
    ({ Sell }) => Sell.getSellVariantsProduct
  )

  const getReduxSellProductDetail = useSelector(
    ({ Sell }) => Sell.getSellProductDetails
  )

  const getReduxSellSelectedProd = useSelector(
    ({ Sell }) => Sell.getSellSelectedProducts
  )

  const getReduxSellSelectedSingleProd = useSelector(
    ({ Sell }) => Sell.getSellSelectedSingleProduct
  )

  const getReduxShowVariantModal = useSelector(
    ({ commonConfigs }) => commonConfigs.getIsShowVariantModal
  )
  const getReduxVariantSelectedProdID = useSelector(
    ({ commonConfigs }) => commonConfigs.getVariantSelectedProdID
  )
  const getReduxIsRegisterOpen = useSelector(
    ({ Sell }) => Sell.cashManageIsRegistorOpen
  )
  const getIsOutInvWarn = useSelector(
    ({ commonConfigs }) => commonConfigs.getIsOutInvWarn
  )
  const getSearchSelectedProduct = useSelector(
    ({ Products }) => Products.searchSelectedProduct
  )
  const showNumPadForDiscount = useSelector(
    ({ Sell }) => Sell.showNumPadForDiscount
  )
  const showNumPadForPayment = useSelector(
    ({ Sell }) => Sell.showNumPadForPayment
  )
  const getReduxStoreInfo = useSelector(
    ({ commonConfigs }) => commonConfigs.getStoreInfo
  )
  const showNumPad = useSelector(({ Sell }) => Sell.showNumPad)
  const checkVariantProds = useSelector(({ Sell }) => Sell.checkVariantProds)
  const showQuickKeys = useSelector(({ Sell }) => Sell.showQuickKeys)
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)
  const screen_width = useSelector(({ settings }) => settings.width)

  const [getSelectedOutlet, setSelectedOutlet] = React.useState('')
  const [options, setOptions] = React.useState([])
  const [getSearchProd, setSearchProd] = useState([])
  // const [visible, setVisible] = useState(false);
  const [filterArray, setfilterArray] = useState(0)
  const [getAttribValue, setAttribValue] = useState('')
  const inputRef = useRef(null)
  // const [getSelectedProdID, setSelectedProdID] = useState("");

  //for selected outlet

  React.useEffect(() => {
    let outletID = ''
    if (getReduxSelectedStoreOutlets.id) {
      outletID = getReduxSelectedStoreOutlets.id
      setSelectedOutlet(outletID)
    } else {
      let selectedLocalOut = localStorage.getItem('selectedOut')
      if (selectedLocalOut) {
        selectedLocalOut = JSON.parse(selectedLocalOut)
        outletID = getReduxSelectedStoreOutlets.id
          ? getReduxSelectedStoreOutlets.id
          : selectedLocalOut.id

        setSelectedOutlet(outletID)
      }
    }

    // //load priceBooks & promotions for selected outlets
    // if (outletID) {
    //   dispatch(loadSalePriceBooks(outletID, isOnline))
    //   dispatch(loadSalePromotions(outletID, isOnline))
    // } else {
    //   message.info('Click on Sell & select Outlet from left menu.', 4)
    // }
  }, [getReduxSelectedStoreOutlets])

  React.useEffect(() => {
    let mounted = true

    if (mounted) {
      if (getSearchSelectedProduct) {
        onSelect(getSearchSelectedProduct)
      }
    }

    return () => (mounted = false)
  }, [getSearchSelectedProduct])

  function prodCheckInStack (id) {
    let callAPI = true
    if (getReduxSellProductDetail && getReduxSellProductDetail.length > 0) {
    }
    return callAPI
  }
  const onSelect = async selectedObj => {
    if (!getReduxIsRegisterOpen) {
      message.info('Kindly open Register to sell products')
    } else {
      let newProd = []
      let productID = ''
      if (selectedObj && selectedObj != null) {
        if (selectedObj.productID) {
          productID = selectedObj.productID
        }
      } else {
        productID = ''
      }
      if (!StringIsNullOrEmpty(productID)) {
        if (prodCheckInStack(selectedObj.productID)) {
          if (
            selectedObj &&
            // selectedObj.productType.includes('Variant') &&
            selectedObj.hasChild &&
            selectedObj.parentProductID < 1
          ) {
            // setVisible(true);
            // setSelectedProdID(product.productID);
            dispatch(loadIsShowVariantModal(true))
            dispatch(
              loadVariatSelectedProdID(
                isString(selectedObj.productID) &&
                  selectedObj.productID.includes('&')
                  ? selectedObj.productID
                  : `${selectedObj.productID}&&_9efa-1ea9-4faf-88ed-a48e65b46643`
              )
            )
            dispatch(loadSellScreenLoading(true))
            let body = {
              productID: getEncryptedID(selectedObj.productID),
              outletID: getSelectedOutlet,
              containVariants: true
            }
            dispatch(
              loadSellProductDetails(
                body,
                getReduxSellProductDetail,
                getReduxSellSelectedProd,
                getIsOutInvWarn,
                isOnline,
                getSelectedOutlet,
                getReduxStoreInfo
              )
            )
          } else {
            let body = {
              productID: getEncryptedID(selectedObj.productID),
              outletID: getSelectedOutlet,
              containVariants: false
            }
            dispatch(
              loadSellProductDetails(
                body,
                getReduxSellProductDetail,
                getReduxSellSelectedProd,
                getIsOutInvWarn,
                isOnline,
                getSelectedOutlet,
                getReduxStoreInfo
              )
            )
          }
        }
        dispatch(loadSearchSelectedProduct([]))
      }
    }
    setOptions([])

    form.setFieldsValue({ ProductSearch: '' })
  }
  const BarCodeSelect = productData => {
    if (productData && productData != null) {
      let product = productData[0]
      if (prodCheckInStack(product.productID)) {
        if (
          product &&
          product.productType.includes('Variant') &&
          product.hasChild &&
          product.parentProductID < 1
        ) {
          // setVisible(true);
          // setSelectedProdID(product.productID);
          dispatch(loadIsShowVariantModal(true))
          dispatch(
            loadVariatSelectedProdID(
              isString(product.productID) && product.productID.includes('&')
                ? product.productID
                : `${product.productID}&&_9efa-1ea9-4faf-88ed-a48e65b46643`
            )
          )
          dispatch(loadSellScreenLoading(true))
          let body = {
            productID: getEncryptedID(product.productID),
            outletID: getSelectedOutlet,
            containVariants: true
          }
          dispatch(
            loadSellProductDetails(
              body,
              getReduxSellProductDetail,
              getReduxSellSelectedProd,
              getIsOutInvWarn,
              isOnline,
              getSelectedOutlet,
              getReduxStoreInfo
            )
          )
        } else {
          form.setFieldsValue({ ProductSearch: product.productName })
          // inputRef.current.focus();
          let body = {
            productID: getEncryptedID(product.productID),
            outletID: getSelectedOutlet,
            containVariants: false
          }
          dispatch(
            loadSellProductDetails(
              body,
              getReduxSellProductDetail,
              getReduxSellSelectedProd,
              getIsOutInvWarn,
              isOnline,
              getSelectedOutlet,
              getReduxStoreInfo
            )
          )
        }
      }
    }
  }
  const handleSearch = async (value, isSKUSearch) => {
    if (value.length > 1) {
      if (getSelectedOutlet) {
        let nameArray = []
        let searchProducts = {
          data: {
            msgCode: '',
            msgDescription: ''
          }
        }
        await ds
          .getBookSearchProd(`?keys=${value}&outletid=${getSelectedOutlet}`)
          .then(response => (searchProducts.data = response.data))
          .catch(e => {
            //  console.log("Product Search Issue", e)
          })

        if (searchProducts.data.msgCode == 'GENERAL_SUCCESS') {
          if (searchProducts.data.data.length > 0) {
            setSearchProd(getSearchProd.concat(searchProducts.data.data))
            nameArray = searchProducts.data.data.map(names => {
              const category = names.productName
              const id = names.productID
              return {
                value: category,
                label: (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between'
                    }}
                  >
                    <span
                      style={{
                        backgroundColor: 'lightcyan',
                        fontStyle: 'oblique',
                        fontWeight: 'bolder'
                      }}
                    >
                      <a>{category}</a>
                    </span>
                    <span>
                      <IntlMessages id='products.addeditpriceprod.searchresult' />
                    </span>
                  </div>
                )
              }
            })
            if (isSKUSearch) {
              BarCodeSelect(searchProducts.data.data)
            }
          } else {
            if (isSKUSearch) {
              message.error("SKU doesn't exist")
            }
          }
          setOptions(nameArray)
        }

        if (searchProducts.data.msgCode == 'GENERAL_ERROR') {
          message.error(searchProducts.data.msgDescription)
        }
      } else {
        message.warn('Kindly click on Sell & select Outlet from left side', 3)
      }
    } else {
      setOptions([])
      setSearchProd([])
    }
  }
  function onAttribClick (value) {
    let slashesAttrib = getAttribValue
      ? getAttribValue.concat(`/${value}`)
      : getAttribValue.concat(`${value}`)
    setAttribValue(slashesAttrib)
    let count = filterArray + 1
    if (count <= getReduxSellVariantProduct.length - 1) {
      setfilterArray(count)
    } else {
      //adding variant prod to the selected prod list
      if (getReduxSellProductDetail.length > 0) {
        let prod = getReduxSellProductDetail.filter(
          a =>
            a.parentProdID.substring(0, a.parentProdID.indexOf('&')) ==
            getReduxVariantSelectedProdID.substring(
              0,
              getReduxVariantSelectedProdID.indexOf('&')
            )
        )[0]
        let selectedProd =
          prod && prod.products && prod.products.length > 0
            ? prod.products.filter(a => a.variantName == slashesAttrib)
            : []
        if (selectedProd.length > 0) {
          if (
            selectedProd[0].productName &&
            !selectedProd[0].productName.includes('(')
          ) {
            selectedProd[0].productName = `${selectedProd[0].productName} (${selectedProd[0].variantName})`
          }
          let supposedArray = getReduxSellSelectedProd
          const prodss = selectedProd[0]
          if (getIsOutInvWarn && prodss && prodss.isProductInventory) {
            if (prodss.currentInventory <= 0) {
              message.warn('You do not have enough inventory', 4)
              setAttribValue('')
              dispatch(loadIsShowVariantModal(false))
              return
            }
          }
          supposedArray = supposedArray.concat(selectedProd[0])
          dispatch(loadSellSelectedProds(supposedArray))
          let addProd = selectedProd[0]
          addProd.key = 0
          dispatch(loadSellSelectedSingleProd(addProd))
          setAttribValue('')
        }
      }
      dispatch(loadSellVariantProd([], true))
      setfilterArray(0)
      // setVisible(false);
      setAttribValue('')
      dispatch(loadIsShowVariantModal(false))
    }
  }
  function variantCanelBtn () {
    setfilterArray(0)
    // setVisible(false);
    dispatch(loadIsShowVariantModal(false))
    dispatch(loadSellVariantProd([], true))
    dispatch(loadCheckProdsVariants([]))
    setAttribValue('')
  }
  const VariantModal = () => {
    return (
      <Modal
        className='product-Variant-modal'
        title={
          <strong>
            {' '}
            <IntlMessages id='sell.sell.variantprod' />{' '}
          </strong>
        }
        centered
        visible={getReduxShowVariantModal}
        footer={
          <>
            <Button
              size='large'
              className='dk-btn-cancel'
              onClick={() => variantCanelBtn()}
            >
              Close
            </Button>
          </>
        }
        onCancel={() => variantCanelBtn()}
      >
        <Spin spinning={getReduxSellScreenLoading} size='default'>
          {getReduxSellVariantProduct && getReduxSellVariantProduct.length > 0 && (
            <>
              <h3>
                {' '}
                <IntlMessages id='sell.sell.selectattrib' />{' '}
                {` ${getReduxSellVariantProduct[filterArray].variantName}`}{' '}
              </h3>

              <Row className='mt-4'>
                {getReduxSellVariantProduct[filterArray].variantAttributes
                  .length > 0 &&
                  getReduxSellVariantProduct[filterArray].variantAttributes.map(
                    (e, key) => {
                      //check if prod of this variant exist
                      let isNotAllow = true
                      if (checkVariantProds && checkVariantProds.length > 0) {
                        const toCheck = getAttribValue
                          ? getAttribValue.concat(`/${e}`)
                          : e
                        checkVariantProds.map(qq => {
                          if (
                            qq &&
                            removeSpacewithLowerCaseString(qq).includes(
                              removeSpacewithLowerCaseString(toCheck)
                            )
                          ) {
                            isNotAllow = false
                          }
                        })
                      }
                      if (isNotAllow) {
                        return
                      }

                      //finding spanwith of the attributes in modal
                      let length = 0
                      let match =
                        getAttribValue && getAttribValue.includes('/')
                          ? getAttribValue.split('/')
                          : []
                      if (match && match.length > 0) {
                        match = match[match.length - 1]
                      } else {
                        match = getAttribValue
                      }
                      if (match) {
                        if (checkVariantProds && checkVariantProds.length > 0) {
                          if (filterArray < 2) {
                            checkVariantProds.map(qq => {
                              if (qq && qq.includes(match)) {
                                length += 1
                              }
                            })
                          }
                        }
                      }

                      let spanWidth = 24
                      let arrayLength =
                        length && length > 0
                          ? length
                          : getReduxSellVariantProduct[filterArray]
                              .variantAttributes.length
                      arrayLength = arrayLength < 0 ? 0 : arrayLength
                      if (arrayLength < 4) {
                        spanWidth = parseInt(spanWidth / arrayLength)
                      } else {
                        spanWidth = parseInt(spanWidth / 3)
                      }

                      return (
                        <Col span={spanWidth} key={key}>
                          <Card
                            hoverable
                            className='product-Variant'
                            onClick={() => {
                              onAttribClick(e)
                            }}
                          >
                            <div className='custome-variantname'>{e}</div>
                          </Card>
                        </Col>
                      )
                    }
                  )}
              </Row>
            </>
          )}
        </Spin>
      </Modal>
    )
  }
  function handleScan (data) {
    handleSearch(data, true)
  }
  function handleError (data) {
    handleSearch(data, true)
    // console.error(err);
  }

  function changeShowQuickKeys (val) {
    // setShowQuickKeys(val ? true : false);
    dispatch(loadShowQuickKey(val ? true : false))
  }

  return (
    <>
      {screen == 'SellScreen' && (
        <div className='Product-Search-or-Scan'>
          <VariantModal />
          {/* {} */}
          <Form
            {...formItemLayout}
            form={form}
            scrollToFirstError
            id='QuickKeyLayoutForm'
            name='QuickKeyLayoutForm'
            className='input-grp'
          >
            <ProductSearch isLabel={false} screen={screen} />
          </Form>
          {checkIsWeb().exist &&
            isMobile &&
            screen_width < LANDSCAPE_QUICK_KEY && (
              <div className='ShowQuickKeys'>
                <Button
                  type='primary'
                  onClick={() => {
                    if (getReduxIsRegisterOpen) {
                      changeShowQuickKeys(!showQuickKeys)
                    } else {
                      message.info('Kindly open Register to sell products')
                    }
                  }}
                >
                  Show <br></br>Quick Keys
                </Button>
              </div>
            )}
          {!showNumPad && !showNumPadForDiscount && !showNumPadForPayment && (
            <BarcodeReader
              onError={e => {
                handleError(e)
              }}
              onScan={e => {
                handleScan(e)
              }}
            />
          )}
        </div>
      )}
    </>
  )
}

export default SearchProduct
